// extracted by mini-css-extract-plugin
export var container = "style-module--container--84f9b";
export var mainList = "style-module--main-list--b10f0";
export var undertext = "style-module--undertext--47c36";
export var wait = "style-module--wait--e5588";